import { Directive, HostBinding, inject } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

/**
 * Directive to add extra properties (e.g. classes) to form controls.
 *
 * Works on following tags: ion-input, ion-select, ion-toggle, ion-textarea
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ion-input, ion-select, ion-toggle, ion-textarea',
    standalone: false
})
export class FormControlOverrideDirective {
  private readonly control = inject(NgControl, { optional: true });

  /**
   * Whether the control has a required validator.
   *
   * Adds the class `required` to the host component when it does.
   */
  @HostBinding('class.required') get isRequired(): boolean {
    return Boolean(this.control?.control?.hasValidator(Validators.required));
  }
}
